module.exports = __webpack_public_path__ + "img/close.d8bb2ffd.png";